import styled from "styled-components/macro";
import { Box } from "./Box";
import { BORDER_RADIUS, THEME_COLOR } from "../vars";

const CellSet = styled.div`
  border-radius: ${BORDER_RADIUS};
  display: flex;
  flex-direction: column;
`;

export default CellSet;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  &:not(:first-child) {
    margin-top: -1px;
  }
`;

export const Item = styled(Box)`
  border-radius: 0;
  flex-grow: 1;
  flex-basis: 0;

  &:not(:first-child) {
    margin-left: -1px;
  }
  &.hidden {
    visibility: hidden;
  }
  ${Row}:first-child > &:first-child,
  &.force-start-top {
    border-top-left-radius: ${BORDER_RADIUS};
  }
  ${Row}:first-child > &:last-child,
  &.force-end-top {
    border-top-right-radius: ${BORDER_RADIUS};
  }
  ${Row}:last-child > &:first-child,
  &.force-start-bottom {
    border-bottom-left-radius: ${BORDER_RADIUS};
  }
  ${Row}:last-child > &:last-child,
  &.force-end-bottom {
    border-bottom-right-radius: ${BORDER_RADIUS};
  }
  ${Row}:last-child > & {
    margin-bottom: -1px;
  }
  ${Row} > &:first-child {
    margin-left: -1px;
  }
  ${Row} > &:last-child {
    margin-right: -1px;
  }
  &.shaded {
    background: #fafafa;
  }
`;

const ItemButtonUnStyled = Item.withComponent("button");
export const ItemButton = styled(ItemButtonUnStyled)`
  min-height: 40px;
  text-align: left;
  padding: 10px;
  padding-left: 60px;
  line-height: 1.4em;
  background: white;
  border-width: 1px;
  border-style: solid;
  border-color: #d7d7d9;
  &:hover {
    background: #fafafa;
  }
  &:active {
    background: #f0f0f0;
  }
  svg {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    color: ${THEME_COLOR};
  }
`;
